<template>
  <div class="landing">
    <header>
      <div class="home">
        <h1>N-Leach</h1>
      </div>
      <div class="language-selector">
        <button
          :class="{ 'active' : $i18n.i18next.language == 'es' }"
          @click="changeLanguage('es')"
          type="button">
          ES
        </button>
        <span class="divider">|</span>
        <button
          :class="{ 'active' : $i18n.i18next.language == 'en' }"
          @click="changeLanguage('en')"
          type="button">
          EN
        </button>
      </div>
    </header>
    <section class="content">
      <h2>{{$t('landing.headline')}}</h2>
      <div class="links">
        <a type="button" class="button--github">
          <n-logo-github/>
          {{$t('landing.link-to-github')}}
        </a>
        <router-link class="button--demo" to="/input">{{$t('landing.try-it')}}</router-link>
      </div>
      <div class="description">
        <p>{{$t('landing.line-1')}}</p>
        <p>{{$t('landing.line-2')}}</p>
      </div>
      <div class="screenshot">
        <img src="~@/assets/images/screenshot.png" />
      </div>
      <div class="description">
        <p>{{$t('landing.line-3')}}</p>
        <p>{{$t('landing.line-4')}}</p>
        <p>{{$t('landing.line-5')}}</p>
        <p>{{$t('landing.line-6')}}</p>
        <p>{{$t('landing.line-7')}}</p>
      </div>
    </section>
    <n-footer />
  </div>
</template>

<style lang="scss" scoped>

header {
  height: var(--height--header);
  min-height: var(--height--header);
  position: sticky;
  top: 0;
  background: var(--background--gradient);
  background-image:
    url("~@/assets/images/pattern-bg.png"),
    var(--background--gradient);
}

.home {
  position: absolute;
  left: $spacing--m;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
}

h1 {
  font-size: 1.25rem;
  text-transform: uppercase;
  color: var(--color--dark--primary);
}

.content {
  padding: $spacing--l;
}

.links {
  margin: $spacing--l 0;
  display: flex;
  justify-content: center;
}

h2,
.description,
.links {
  width: 800px;
  margin: $spacing--xl auto;
}

h2 {
  text-align: center;
}

.button--demo,
.button--github {
  @extend %text-style--button;
  display: flex;
  align-items: center;
  height: $spacing--l;
  padding: 0 $spacing--m;
  color: var(--color--white);
}

.screenshot {
  width: 1024px;
  margin: $spacing--l auto;
  box-shadow:
    0 0 2px hsla(168, 10%, 16%, 0.12),
    0 0.125rem 0.125rem hsla(168, 10%, 16%, 0.12),
    0 1rem 1rem hsla(168, 10%, 16%, 0.12),
    0 2rem 4rem hsla(168, 10%, 16%, 0.12);
  img {
    display: block;
    width: 100%;
  }
}

.button--demo {
  background-color: var(--color--action);
  margin-left: $spacing--s;
}

.button--github {
  background-color: var(--color--primary);
  svg {
    margin-right: $spacing--xxs;
    fill: var(--color--white);
  }
}

.language-selector {
  position: absolute;
  right: $spacing--m;
  top: 50%;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
  color: var(--color--dark--secondary);
  button {
    padding: 0.25rem;
    background-color: transparent;
    color: var(--color--dark--secondary);
    &.active {
      pointer-events: none;
      color: var(--color--dark--primary);
    }
  }
}

</style>

<script>
import Footer from '@/components/Footer'
import LogoGithub from '@/components/LogoGithub'

export default {
  name: 'home',
  components: {
    'n-logo-github': LogoGithub,
    'n-footer': Footer
  },
  methods: {
    changeLanguage (lang) {
      this.$i18n.i18next.changeLanguage(lang)
    }
  }
}
</script>
